import React from "react";

const FourtofourPage = () => {
  return (
    <div className="h-[100vh] flex justify-center items-center">
      <div>
        <lottie-player
          src="https://assets5.lottiefiles.com/packages/lf20_6nmazhqu.json"
          background="transparent"
          speed="1"
          style={{ width: "400px", height: "400px" }}
          loop
          autoplay
        ></lottie-player>
      </div>
    </div>
  );
};

export default FourtofourPage;
